import IconEmptyTable from '@/assets/icons/ic-empty-table.svg';
import { EMPTY_STATE_MESSAGES } from '../../constants/audienceDefaults';

interface AudienceEmptyStateProps {
    hasSelectedTags: boolean;
}

export const AudienceEmptyState = ({ hasSelectedTags }: AudienceEmptyStateProps) => {
    const message = hasSelectedTags ? EMPTY_STATE_MESSAGES.NO_MATCHES : EMPTY_STATE_MESSAGES.NO_TAGS;

    return (
        <div className='flex min-h-80 flex-col items-center justify-center gap-4 py-8 text-center'>
            {/* {EmptyTableIcon} */}
            <IconEmptyTable className='size-20' />
            <div className='flex flex-col gap-3'>
                <h3>{message.header}</h3>
                <p className='text-body-sm md:text-body-md max-w-80 font-light'>{message.subheader}</p>
            </div>
        </div>
    );
};
